import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  getRotaStatsFailure,
  getRotaStatsSuccess,
  getSurveyStatsFailure,
  getSurveyStatsSuccess,
  getUserStatsFailure,
  getUserStatsSuccess,
  // modern dashboard
  getHrStatsFailure,
  getHrStatsSuccess,
  getShiftApprovalsFailure,
  getShiftApprovalsSuccess,
  getStaffOpsFailure,
  getStaffOpsSuccess,
  getTeamActivityFailure,
  getTeamActivitySuccess,
  getLeadAnalyticsFailure,
  getLeadAnalyticsSuccess,
  getTeamCommFailure,
  getTeamCommSuccess,
} from "./actions";
import {
  GET_ROTA_STATS,
  GET_SURVEY_STATS,
  GET_USER_STATS,
  // modern dashboard
  GET_HR_STATS,
  GET_SHIFT_APPROVALS,
  GET_STAFF_OPS,
  GET_TEAM_ACTIVITY,
  GET_LEAD_ANALYTICS,
  GET_TEAM_COMM,
} from "./constants";

export const formatExpiringDocs = (docs) => {
  if (!docs || !Array.isArray(docs) || docs.length === 0) {
    return {
      display_docs: [],
      all_docs: [],
    };
  }

  const formattedDocs = {
    display_docs: docs.slice(0, 3),
    all_docs: docs,
  };

  return formattedDocs;
};

export const formatBirthdayList = (birthdayList) => {
  const todayBirthdays = birthdayList?.today || [];
  const upcomingBirthdays = birthdayList?.tomorrow || [];

  // merge today and tomorrow
  const combinedBirthdays = [
    ...todayBirthdays.map((item) => ({ ...item, type: "Today" })),
    ...upcomingBirthdays.map((item) => ({ ...item, type: "Tomorrow" })),
  ];

  return combinedBirthdays;
};

export function* getUserStatsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/get-employee-stats?${query}`,
    );
    const formattedData = {
      ...data,
      expiringDocs: formatExpiringDocs(data?.expiring_documents),
      birthdayList: data?.birthday_list?.current_week,
    };
    yield put(getUserStatsSuccess(formattedData));
  } catch (e) {
    yield put(getUserStatsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching employee stats!"));
  }
}

export function* getRotaStatsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(api(token).get, `/api/get-rota-stats?${query}`);
    yield put(getRotaStatsSuccess(data));
  } catch (e) {
    yield put(getRotaStatsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching rota stats!"));
  }
}

export function* getHrStatsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/home/hr-complaince-overview?${query}`,
    );
    yield put(getHrStatsSuccess(data));
  } catch (e) {
    yield put(getHrStatsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching hr stats!"));
  }
}

export function* getSurveyStatsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/home/survey-stats?${query}`,
    );

    yield put(getSurveyStatsSuccess(data));
  } catch (e) {
    yield put(getSurveyStatsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching survey stats!"));
  }
}

export function* getShiftApprovalsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/home/shift-management-approvals?${query}`,
    );
    yield put(getShiftApprovalsSuccess(data));
  } catch (e) {
    yield put(getShiftApprovalsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching shift approvals!"));
  }
}

export function* getStaffOpsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/home/staff-management-operations?${query}`,
    );
    yield put(getStaffOpsSuccess(data));
  } catch (e) {
    yield put(getStaffOpsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching staff ops!"));
  }
}

export function* getTeamActivitySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/home/team-and-activities?${query}`,
    );
    yield put(getTeamActivitySuccess(data));
  } catch (e) {
    yield put(getTeamActivityFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching team activity!"));
  }
}

export function* getLeadAnalyticsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/home/leads-and-analytics?${query}`,
    );
    yield put(getLeadAnalyticsSuccess(data));
  } catch (e) {
    yield put(getLeadAnalyticsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching lead analytics!"));
  }
}

export function* getTeamCommSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/home/team-communication?${query}`,
    );
    yield put(getTeamCommSuccess(data));
  } catch (e) {
    yield put(getTeamCommFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching team communication!"));
  }
}

export function* getUserStatsFlow() {
  yield takeEvery(GET_USER_STATS, getUserStatsSaga);
}

export function* getRotaStatsFlow() {
  yield takeEvery(GET_ROTA_STATS, getRotaStatsSaga);
}

export function* getSurveyStatsFlow() {
  yield takeEvery(GET_SURVEY_STATS, getSurveyStatsSaga);
}

export function* getHrStatsFlow() {
  yield takeEvery(GET_HR_STATS, getHrStatsSaga);
}

export function* getShiftApprovalsFlow() {
  yield takeEvery(GET_SHIFT_APPROVALS, getShiftApprovalsSaga);
}

export function* getStaffOpsFlow() {
  yield takeEvery(GET_STAFF_OPS, getStaffOpsSaga);
}

export function* getTeamActivityFlow() {
  yield takeEvery(GET_TEAM_ACTIVITY, getTeamActivitySaga);
}

export function* getLeadAnalyticsFlow() {
  yield takeEvery(GET_LEAD_ANALYTICS, getLeadAnalyticsSaga);
}

export function* getTeamCommFlow() {
  yield takeEvery(GET_TEAM_COMM, getTeamCommSaga);
}

export default function* StatsSaga() {
  yield all([
    getUserStatsFlow(),
    getRotaStatsFlow(),
    getSurveyStatsFlow(),
    getHrStatsFlow(),
    getShiftApprovalsFlow(),
    getStaffOpsFlow(),
    getTeamActivityFlow(),
    getLeadAnalyticsFlow(),
    getTeamCommFlow(),
  ]);
}
